import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button/Button';
import styles from './GiftCardGuestBanner.module.css';

/**
 * GiftCardGuestBanner Component
 * Banner for non-logged-in users explaining the gift card system
 */
const GiftCardGuestBanner = () => {
  const navigate = useNavigate();

  const handleSignupClick = () => {
    navigate('/login?modalType=auth-signup');
  };

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerCard}>
        {/* Gradient Background */}
        <div className={styles.bannerGradient}></div>
        
        {/* Gift Box Image */}
        <div className={styles.bannerImageContainer}>
          <img 
            className={styles.bannerImage}
            src="/assets/images/gift-purple.webp"
            alt="Gift Card"
            loading="lazy"
            onError={(e) => {
              e.target.src = '/assets/images/bonus-welcome-banner.webp';
            }}
          />
        </div>
        
        {/* Content Section */}
        <div className={styles.bannerContent}>
          <h2 className={styles.bannerTitle}>
            Gift Card Voucher System
          </h2>
          <p className={styles.bannerDescription}>
            Activate gift cards with unique codes, complete wager requirements, and claim rewards to boost your wallet balance.
          </p>
          
          <div className={styles.bannerAction}>
            <div className={styles.bannerStatus}>
              <span className={styles.statusLabel}>Available to claim</span>
              <button className={styles.infoButton} aria-label="More information">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M8 6V8M8 10H8.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            <Button
              variant="primary"
              size="lg"
              onClick={handleSignupClick}
              className={styles.signupButton}
            >
              Signup to claim
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardGuestBanner;
